import React from "react";

function IconBase({ size = 18, children, ...props }) {
    return (
        <svg
            aria-hidden="true"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            {...props}
        >
            {children}
        </svg>
    );
}

export function PaperclipIcon(props) {
    return (
        <IconBase {...props}>
            <path d="m21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
        </IconBase>
    );
}

export function TruckIcon(props) {
    return (
        <IconBase {...props}>
            <path d="M10 17h4V5H2v12h3" />
            <path d="M14 9h4l4 4v4h-3" />
            <circle cx="7.5" cy="17.5" r="2.5" />
            <circle cx="16.5" cy="17.5" r="2.5" />
        </IconBase>
    );
}

export function CameraIcon(props) {
    return (
        <IconBase {...props}>
            <path d="M14.5 4 16 7h3a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h3l1.5-3Z" />
            <circle cx="12" cy="13" r="3" />
        </IconBase>
    );
}

export function SendIcon(props) {
    return (
        <IconBase {...props}>
            <path d="m22 2-7 20-4-9-9-4Z" />
            <path d="M22 2 11 13" />
        </IconBase>
    );
}

export function ArrowLeftIcon(props) {
    return (
        <IconBase {...props}>
            <path d="m15 18-6-6 6-6" />
            <path d="M9 12h10" />
        </IconBase>
    );
}
